"use client";

import { Language } from "@linqx/i18n";
import { VelocityMarquee } from "@/components/motion/velocity-marquee";

const ROW_ONE = [
  Language.getKey("landing_marquee_no_small_talk"),
  Language.getKey("landing_marquee_real_connections"),
  Language.getKey("landing_marquee_meet_irl"),
  Language.getKey("landing_marquee_share_the_night"),
];

const ROW_TWO = [
  Language.getKey("landing_marquee_adventure"),
  Language.getKey("landing_marquee_nightlife"),
  Language.getKey("landing_marquee_coffee_dates"),
  Language.getKey("landing_marquee_live_music"),
  Language.getKey("landing_marquee_city_explorers"),
];

/**
 * A full-bleed, scroll-velocity-reactive marquee band that bridges the hero
 * and the rest of the page with kinetic energy. Two rows scroll in opposite
 * directions and surge with the page's scroll velocity.
 */
export function MarqueeBand() {
  return (
    <section className="relative overflow-hidden bg-brand-900 py-10 md:py-14">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-brand-900 to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-brand-900 to-transparent" />

      <VelocityMarquee
        items={ROW_ONE}
        baseVelocity={-3}
        className="text-3xl text-white md:text-5xl"
      />
      <VelocityMarquee
        items={ROW_TWO}
        baseVelocity={3}
        outline
        className="mt-2 text-3xl text-brand-300 md:text-5xl"
      />
    </section>
  );
}
